import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "components/generales/Navbar";
import Boton from "components/boton/Boton";
import axios from "axios";
import FormularioIngresos from "components/ingresos/FormularioIngresos";

const EditarIngreso = () => {
  const [ingreso, setIngreso] = useState({});
  const [cargando, setCargando] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const obtenerIngresoApi = async () => {
      try {
        const { data } = await axios.get(
          `https://mymoney5.herokuapp.com/ingreso/${id}`
        );
        setIngreso(data);
      } catch (error) {}
      setCargando(false);
    };
    obtenerIngresoApi();
  }, []);

  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenIngreso"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Editar Ingreso</h2>
            {ingreso?.descripcion ? (
              <FormularioIngresos ingreso={ingreso} cargando={cargando} />
            ) : (
              <p className="formulario-error">Ingreso no encontrado</p>
            )}

            <Boton
              type="button"
              buttonStyle="botonPrimarioSolido"
              onClick={() => navigate(`/ingresos/`)}
            >
              Regresar
            </Boton>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditarIngreso;
